module.exports = __webpack_public_path__ + "static/media/51.32ef3e87.mp3";